import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=50f1979f&"
import script from "./VPagination.vue?vue&type=script&lang=ts&"
export * from "./VPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports